export default __webpack_public_path__ + "static/media/thunderstorm.7b4a3451.png";